<template>
    <Form as="" :validation-schema="schema" v-slot="{ meta, handleSubmit }">
        <bs5-base-modal :title="$t('users.passwordTitle')" :visible="visible" @close="closeModal">
            <template v-slot:default>
                <form novalidate @submit.prevent="handleSubmit($event, setPassword)">
                    <bs5-form-field id="setPasswordNew" name="newPassword" type="password" icon="bi-key"
                        autocomplete="new-password" :label="$t('users.newPassword')" :hint="$t('account.policy')"
                        v-model="password.newPassword" />
                    <bs5-form-field id="setPasswordConfirm" name="confirmNewPassword" type="password" icon="bi-key"
                        autocomplete="new-password" :label="$t('users.confirmPassword')"
                        v-model="password.confirmNewPassword" />
                    <button type="submit" class="d-none" tabindex="-1" aria-hidden="true"></button>
                </form>
            </template>

            <template v-slot:footer>
                <bs5-cancel-button @click="closeModal" />
                <bs5-save-button :loading="saving" :disabled="!meta.valid" @click="handleSubmit($event, setPassword)">
                    <i class="bi bi-key"></i>{{ $t("common.save") }}
                </bs5-save-button>
            </template>
        </bs5-base-modal>
    </Form>
</template>

<script lang="ts">
import { t } from "@/helpers/i18n";
import { defineComponent, ref } from "vue";
import { Form } from "vee-validate";
import * as yup from "yup";
import userService from "@/services/user.service";
import { showToast } from "@/utils/toast";
import { newPassword, passwordConfirmation } from "@/utils/validation";

export default defineComponent({
    name: "SetPasswordModal",
    components: { Form },
    props: {
        visible: { type: Boolean, required: true },
        userId: { type: String, required: true },
    },
    emits: ["close", "password-set"],
    data() {
        return {
            password: ref({
                newPassword: "",
                confirmNewPassword: "",
            }),
            saving: ref(false),
        };
    },
    computed: {
        schema() {
            return yup.object({
                newPassword: newPassword(),
                confirmNewPassword: passwordConfirmation("newPassword"),
            });
        },
    },
    watch: {
        visible(isVisible: boolean) {
            if (isVisible) {
                // Hasło wpisane przy poprzednim otwarciu nie może zostać w formularzu
                this.password = { newPassword: "", confirmNewPassword: "" };
            }
        },
    },
    methods: {
        async setPassword() {
            this.saving = true;
            try {
                await userService.setPassword(this.userId, this.password.newPassword, this.password.confirmNewPassword);
                this.$emit("password-set");
                this.closeModal();
                showToast(t("users.passwordChanged"), "success");
            } catch (error) {
                showToast(t("users.passwordFailed"), "error");
                console.error("Error setting password:", error);
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>
